<template>
  <div id="detailDiv">
    <Divider orientation="left">用户资料上传记录</Divider>
    <Table border highlight-row :columns="uploadColumns" :data="dataMap.uploadLog"></Table>
    <Divider orientation="left">金额汇总数据<span
      v-if="dataMap.invalid_money">(剔除交易总金额：{{ Number(dataMap.invalid_money).toFixed(0) }})</span></Divider>
    <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj"></Table>
    <Divider orientation="left" v-if="dataMap.bank_daily_avg_balance">日均余额数据</Divider>
    <Table border highlight-row :columns="dailyAvgColumns" :data="dataMap.bank_daily_avg_balance"></Table>
    <Divider orientation="left" v-if="dataMap.wages_info_summer">工资信息</Divider>
    <Table border highlight-row :columns="wagesInfoColumns" :data="dataMap.wages_info_summer"></Table>
    <Divider orientation="left" v-if="dataMap.pos_trade_summer">收单信息</Divider>
    <Table border highlight-row :columns="posTradeInfoColumns" :data="dataMap.pos_trade_summer"></Table>
    <Divider orientation="left">小额交易汇总数据（五千以下）</Divider>
    <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj_wq_yx"></Table>
    <h3></h3><br>
    <h2>分渠道汇总</h2>
    <Divider orientation="left" v-if="dataMap.bill_stat_weixin">微信汇总数据</Divider>
    <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_weixin"
           v-if="dataMap.bill_stat_weixin"></Table>
    <Divider orientation="left" v-if="dataMap.bill_stat_zhifubao">支付宝汇总数据</Divider>
    <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_zhifubao"
           v-if="dataMap.bill_stat_zhifubao"></Table>
    <Divider orientation="left" v-if="dataMap.bill_stat_bank">银行汇总数据</Divider>
    <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_bank"
           v-if="dataMap.bill_stat_bank"></Table>
    <Divider orientation="left">月度交易数据</Divider>
    <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.monthlySummaryList"></Table>
    <h2>负面相关交易数据</h2>
    <Divider orientation="left">司法相关交易</Divider>
    <Table border highlight-row :columns="tradeInfoColumns"
           :data="dataMap.judicial_trade_list"></Table>
    <Divider orientation="left">异常交易</Divider>
    <Table border highlight-row :columns="tradeInfoColumns"
           :data="dataMap.error_flow_list"></Table>
    <Divider orientation="left">高频转账交易</Divider>
    <Table border highlight-row :columns="highFrequencyTradeInfoColumns"
           :data="dataMap.high_frequency_transfer_list"></Table>
    <Divider orientation="left">夜间交易</Divider>
    <Table border highlight-row :columns="transferBaseColumns"
           :data="dataMap.night_trade_list"></Table>
    <Divider orientation="left">娱乐相关交易</Divider>
    <Table border highlight-row :columns="tradeInfoColumns"
           :data="dataMap.leisure_entertainment_list"></Table>
    <Divider orientation="left" v-if="dataMap.pawn_trading_list!=''">典当相关交易</Divider>
    <Table border highlight-row :columns="tradeInfoColumns"
           :data="dataMap.pawn_trading_list" v-if="dataMap.pawn_trading_list!=''"></Table>
    <h3></h3><br>
    <h2>消费信贷汇总</h2>
    <Divider orientation="left" v-if="dataMap.credit_card_summary">卡交易数据</Divider>
    <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.credit_card_summary"></Table>
    <Divider orientation="left" v-if="dataMap.repayment_summary">还款数据</Divider>
    <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.repayment_summary"></Table>
    <h3></h3><br>
    <h2>理财信息汇总</h2>
    <Divider orientation="left" v-if="dataMap.yueebao_daily_avg_balance">余额宝数据</Divider>
    <Table border highlight-row :columns="yuebaoColumns" :data="dataMap.yueebao_daily_avg_balance"></Table>
    <Divider orientation="left" v-if="dataMap.manage_money_trade_summer">理财数据</Divider>
    <Table border highlight-row :columns="manageMoneyColumns" :data="dataMap.manage_money_trade_summer"></Table>
    <h3></h3><br>
    <h2>生活类交易数据汇总</h2>
    <Divider orientation="left" v-if="dataMap.online_shopping_summary">电商消费数据</Divider>
    <Table border highlight-row :columns="onlineShoppingColumns" :data="dataMap.online_shopping_summary"></Table>
    <Divider orientation="left" v-if="dataMap.phone_monthly_summary">话费支出</Divider>
    <Table border highlight-row :columns="lifeColumns" :data="dataMap.phone_monthly_summary"></Table>
    <Divider orientation="left" v-if="dataMap.sdm_monthly_summary">水电煤支出</Divider>
    <Table border highlight-row :columns="lifeColumns" :data="dataMap.sdm_monthly_summary"></Table>
    <Divider orientation="left" v-if="dataMap.car_monthly_summary">汽车相关支出（包括：加油、停车）</Divider>
    <Table border highlight-row :columns="lifeColumns" :data="dataMap.car_monthly_summary"></Table>
    <Divider orientation="left" v-if="dataMap.travel_monthly_summary">出行旅游相关支出（包括：火车、飞机、酒店）
    </Divider>
    <Table border highlight-row :columns="lifeColumns" :data="dataMap.travel_monthly_summary"></Table>
    <h3></h3><br>
    <h2>转账交易数据汇总</h2>
    <Divider orientation="left">转账汇总</Divider>
    <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.transfer_monthly_summary"></Table>
    <Divider orientation="left">主要转账交易金额对手</Divider>
    <Table border highlight-row :columns="transferBaseColumns"
           :data="dataMap.transfer_counterparty_summary"></Table>
    <Divider orientation="left">主要转账交易次数对手</Divider>
    <Table border highlight-row :columns="transferBaseColumns"
           :data="dataMap.transfer_counterparty_count_summary"></Table>
    <h2>交易类数据汇总</h2>
    <Divider orientation="left">主要消费对手交易</Divider>
    <Table border highlight-row :columns="payBaseColumns" :data="dataMap.pay_counterparty_count_summary"></Table>
    <Divider orientation="left">主要大额消费详情</Divider>
    <Table border highlight-row :columns="payDetailColumns" :data="dataMap.pay_counterparty_max_detail"></Table>
  </div>
</template>
<script>

export default {
  name: 'content-detail',
  props: {
    dataMap: {
      type: Object
    }
  },
  data () {
    return {
      uploadColumns:
        [{
          title: '账单类型',
          key: 'billType'
        }, {
          title: '用户账户',
          key: 'bankCardNo'
        }, {
          title: '上传时间',
          key: 'uploadTime'
        }, {
          title: '开始时间',
          key: 'startTime'
        }, {
          title: '结束时间',
          key: 'endTime'
        }, {
          title: '总金额',
          key: 'money'
        }],
      payDetailColumns: [{
        title: '付款方式',
        key: 'flowCard'
      }, {
        title: '交易对手',
        key: 'counterparty'
      }, {
        title: '金额',
        key: 'money'
      }, {
        title: '商品说明',
        key: 'goodsDesc'
      }],
      payBaseColumns:
        [{
          title: '交易对数',
          key: 'businessType'
        }, {
          title: '交易金额',
          key: 'money'
        }, {
          title: '交易次数',
          key: 'countData'
        }, {
          title: '排名',
          key: 'rankData'
        }],

      statBaseColumns:
        [{
          title: '交易类型',
          key: 'businessType'
        }, {
          title: '金额',
          key: 'money'
        }, {
          title: '笔数',
          key: 'countData'
        }, {
          title: '年均',
          key: 'yearAvg'
        }, {
          title: '月均',
          key: 'monthAvg'
        }, {
          title: '排名',
          key: 'rankData',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          }
        }],
      monthlySummaryColumns:
        [{
          title: '月份',
          key: 'statDesc'
        }, {
          title: '收入',
          key: 'income'
        }, {
          title: '支出',
          key: 'payout'
        }, {
          title: '其他',
          key: 'other'
        }, {
          title: '不计收入',
          key: 'notRecording'
        }],
      cardBaseColumns:
        [{
          title: '银行/账户',
          key: 'cardNo'
        }, {
          title: '金额',
          key: 'money'
        }, {
          title: '笔数',
          key: 'countData'
        }, {
          title: '年均',
          key: 'yearAvg'
        }, {
          title: '月均',
          key: 'monthAvg'
        }, {
          title: '排名',
          key: 'rankData',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          }
        }],
      dailyAvgColumns:
        [{
          title: '银行卡',
          key: 'cardNo'
        }, {
          title: '统计开始日期',
          key: 'startTime'
        }, {
          title: '统计结束日期',
          key: 'endTime'
        }, {
          title: '日均',
          key: 'dayAvg'
        }, {
          title: '活跃天数',
          key: 'countData',
          render: (h, params) => {
            return h('div', [
              h('strong', '近' + params.row.countData + '天')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          }
        }],
      yuebaoColumns:
        [{
          title: '交易类型',
          key: 'businessType'
        }, {
          title: '日均金额',
          key: 'money'
        }, {
          title: '日均生息',
          key: 'dayAvg'
        }, {
          title: '持有天数',
          key: 'countData'
        }, {
          title: '排名',
          key: 'rankData',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          }
        }],
      manageMoneyColumns:
        [{
          title: '理财类型',
          key: 'businessType'
        }, {
          title: '交易总额',
          key: 'money'
        }, {
          title: '交易次数',
          key: 'countData'
        }, {
          title: '买入金额',
          key: 'yearAvg'
        }, {
          title: '卖出金额',
          key: 'monthAvg'
        }],
      lifeColumns:
        [{
          title: '交易月份',
          key: 'statTime'
        }, {
          title: '交易总额',
          key: 'money'
        }, {
          title: '交易次数',
          key: 'countData'
        }, {
          title: '排名',
          key: 'rankData'
        }],
      onlineShoppingColumns:
        [{
          title: '品牌',
          key: 'businessType'
        }, {
          title: '交易总额',
          key: 'money'
        }, {
          title: '交易次数',
          key: 'countData'
        }, {
          title: '件均消费',
          key: 'dayAvg'
        }, {
          title: '月均消费',
          key: 'monthAvg'
        }, {
          title: '排名',
          key: 'rankData'
        }],
      transferBaseColumns:
        [{
          title: '交易对手',
          key: 'businessType'
        }, {
          title: '交易总额',
          key: 'money'
        }, {
          title: '交易次数',
          key: 'countData'
        }, {
          title: '收入',
          key: 'yearAvg'
        }, {
          title: '支出',
          key: 'monthAvg'
        }, {
          title: '排名',
          key: 'rankData'
        }],
      wagesInfoColumns:
        [{
          title: '工资总额',
          key: 'money'
        }, {
          title: '发放次数',
          key: 'countData'
        }, {
          title: '月均工资',
          key: 'monthAvg'
        }, {
          title: '最高',
          key: 'yearAvg'
        }, {
          title: '最低',
          key: 'dayAvg'
        }, {
          title: '排名',
          key: 'rankData',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          }
        }],
      posTradeInfoColumns:
        [{
          title: '收单总额',
          key: 'money'
        }, {
          title: '累计月份',
          key: 'countData'
        }, {
          title: '月均收款',
          key: 'monthAvg'
        }, {
          title: '最高',
          key: 'yearAvg'
        }, {
          title: '最低',
          key: 'dayAvg'
        }, {
          title: '排名',
          key: 'rankData',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          }
        }],
      tradeInfoColumns: [{
        title: '交易对手',
        key: 'counterparty'
      }, {
        title: '交易时间',
        key: 'flowTime'
      }, {
        title: '交易类型',
        key: 'flowType'
      }, {
        title: '交易方向',
        key: 'flowDirection'
      }, {
        title: '交易金额',
        key: 'money'
      }, {
        title: '金额',
        key: 'balance'
      }],
      highFrequencyTradeInfoColumns: [{
        title: '交易对手',
        key: 'counterparty'
      }, {
        title: '交易时间',
        key: 'flowTime',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.flowTime.slice(0, 10))
          ])
        }
      }, {
        title: '交易次数',
        key: 'flowType'
      }, {
        title: '交易金额',
        key: 'money'
      }]
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap, this.$parent.homeStat)
  },
  methods: {
    setData (dataMap, homeStat) {
      if (Number(homeStat.statMonth) < 12) {
        if (typeof dataMap.hz_sj !== 'undefined') {
          dataMap.hz_sj.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.hz_sj_wq_yx !== 'undefined') {
          dataMap.hz_sj_wq_yx.forEach(element => {
            element.yearAvg = '-'
          })
        }

        if (typeof dataMap.bill_stat_weixin !== 'undefined') {
          dataMap.bill_stat_weixin.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.bill_stat_zhifubao !== 'undefined') {
          dataMap.bill_stat_zhifubao.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.bill_stat_bank !== 'undefined') {
          dataMap.bill_stat_bank.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.credit_card_summary !== 'undefined') {
          dataMap.credit_card_summary.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.repayment_summary !== 'undefined') {
          dataMap.repayment_summary.forEach(element => {
            element.yearAvg = '-'
          })
        }
      }

      this.dataMap = this.getDataMap()
      this.dataMap = dataMap
    },
    getDataMap () {
      return {
        uploadLog: [],
        hz_sj: [],
        hz_sj_yw_yx: [],
        hz_sj_wq_yx: [],
        bill_stat_weixin: [],
        bill_stat_zhifubao: [],
        bill_stat_bank: [],
        monthlySummaryList: [],
        credit_card_summary: [],
        repayment_summary: [],
        yueebao_daily_avg_balance: [],
        manage_money_trade_summer: [],
        phone_monthly_summary: [],
        sdm_monthly_summary: [],
        car_monthly_summary: [],
        travel_monthly_summary: [],
        transfer_monthly_summary: [],
        transfer_counterparty_summary: [],
        transfer_counterparty_count_summary: [],
        transfer_counterparty_night_count_summary: [],
        judicial_trade_list: [],
        error_flow_list: [],
        leisure_entertainment_list: [],
        pay_counterparty_count_summary: [],
        pay_counterparty_max_detail: [],
        bank_daily_avg_balance: [],
        wages_info_summer: [],
        pos_trade_summer: [],
        online_shopping_summary: [],
        bank_balance_list: [],
        high_frequency_transfer_list: [],
        night_trade_list: []
      }
    }
  }
}
</script>
<style>
</style>
